import React from 'react';

class IconOffline extends React.Component {
  render() {
    return (
      <>
        <svg
          width="32"
          height="32"
          viewBox="0 0 32 32"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M7.42806 14.6667H4.07328C4.49317 10.8683 6.68588 7.60425 9.80566 5.72029C9.7655 5.79087 9.72592 5.86194 9.68692 5.93344C8.41239 8.27008 7.59976 11.3234 7.42806 14.6667ZM1.33337 16C1.33337 7.89983 7.89986 1.33334 16 1.33334C24.1002 1.33334 30.6667 7.89983 30.6667 16C30.6667 16.4495 30.6465 16.8942 30.6069 17.3333H27.9268H24.572H21.9015H17.3334V27.6637V30.6069C16.8942 30.6465 16.4495 30.6667 16 30.6667C7.89986 30.6667 1.33337 24.1002 1.33337 16ZM12.028 7.21038C12.8397 5.7223 13.7604 4.7915 14.6667 4.33631V14.6667H10.0986C10.2678 11.7122 10.9913 9.11094 12.028 7.21038ZM10.0986 17.3333H14.6667V27.6637C13.7604 27.2085 12.8397 26.2777 12.028 24.7896C10.9913 22.8891 10.2678 20.2878 10.0986 17.3333ZM9.68692 26.0666C9.72592 26.1381 9.7655 26.2091 9.80566 26.2797C6.68588 24.3958 4.49317 21.1317 4.07328 17.3333H7.42806C7.59976 20.6766 8.41239 23.7299 9.68692 26.0666ZM17.3334 14.6667H21.9015C21.7322 11.7122 21.0088 9.11094 19.9721 7.21038C19.1604 5.7223 18.2397 4.7915 17.3334 4.33631V14.6667ZM22.3132 5.93344C23.5877 8.27008 24.4003 11.3234 24.572 14.6667H27.9268C27.5069 10.8683 25.3142 7.60425 22.1944 5.72029C22.2346 5.79087 22.2742 5.86194 22.3132 5.93344ZM23.4478 25.3333L20.3906 22.2761L22.2762 20.3905L25.3334 23.4477L28.3906 20.3905L30.2762 22.2761L27.219 25.3333L30.2762 28.3905L28.3906 30.2761L25.3334 27.219L22.2762 30.2761L20.3906 28.3905L23.4478 25.3333Z"
            fill="#8A8B8D"
          />
        </svg>
      </>
    );
  }
}

export default IconOffline;
